import { render } from "./NcrmWorkflowsHome.vue?vue&type=template&id=6cc66b7e"
import script from "./NcrmWorkflowsHome.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowsHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__